
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/[userHashId]",
      function () {
        return require("private-next-pages/profile/[userHashId]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/[userHashId]"])
      });
    }
  